import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { BaseUrl } from "../../helper/BaseUrl";
import CustomImageUpload from "../../component/CustomImageUpload";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const branchEditEndpoint = ApiEndpoints.branch.branchEdit;
const branchUpdateEndpoint = ApiEndpoints.branch.branchUpdate;

export default function BranchEdit() {
  const navigate = useNavigate();
  const { branch_id } = useParams();

  const [previews, setPreviews] = useState({ thumbnail: null, });

  const [postData, setPostData] = useState({ name: "", branch_slug: "", address: "", contact: "", email: "", thumbnail: null, branch_id: branch_id, });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiRequest("GET", `${branchEditEndpoint}${branch_id}`,);
        setPostData((prev) => ({
          ...prev,
          ...response.branch
        }));

        setPreviews({thumbnail: BaseUrl + response.branch.thumbnail || "" });

      } catch (error) {
        console.error("Error fetching branch data:", error);
      }
    };

    fetchData();
  }, [branch_id]);


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files) {
      const file = files[0];

      // Update the previews state
      setPreviews((prev) => ({
        ...prev,
        [name]: URL.createObjectURL(file),
      }));

      // Update the postData state
      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    for (const [key, value] of Object.entries(postData)) {
      if (key === "name" || key === "address" || key === "contact" || key === "email" || key === "thumbnail") {
        if (value === "" || value === null) {
          toast.error(`The field "${key}" is mandatory.`);
          return;
        }
      }
    }

    const formData = new FormData();
    Object.entries(postData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    // Validate phone number (only digits, 10 digits typically)
    // if (!/^[0-9]+$/.test(postData.contact)) {
    //   toast.error("Phone Number should contain only digits.");
    //   return;
    // }

    // Check if phone number has exactly 10 digits
    // if (postData.contact.length !== 10) {
    //   toast.error("Phone Number should be exactly 10 digits long.");
    //   return;
    // }

    try {
      const response = await ApiRequest("POST", branchUpdateEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success(response.message);
      navigate("/branch");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Branch Management',
    user: 'Admin',
    innerpage: 'Branch Management / Edit Branch'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-content-page">
        <form id="branchEdit" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Branch Name<small>*</small></label>
                  </div>
                  <input value={postData.name} onChange={handleChange} name="name" type="text" className="form-control" placeholder="Enter Name" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Branch Slug<small>*</small></label>
                  </div>
                  <input value={postData.branch_slug} onChange={handleChange} name="branch_slug" type="text" className="form-control" placeholder="Enter Branch Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Phone<small>*</small></label>
                  </div>
                  <input value={postData.contact} onChange={handleChange} name="contact" type="tel" placeholder="Phone Number" className="form-control" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Email<small>*</small></label>
                  </div>
                  <input value={postData.email} onChange={handleChange} name="email" type="email" placeholder="Enter Email" className="form-control" />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Address<small>*</small></label>
                  </div>
                  <input value={postData.address} onChange={handleChange} name="address" type="text" className="form-control" placeholder="Enter Address" />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs input-add-image">
                  <div className="label-wrap-add">
                    <label>Thumbnail Image (444 × 253)<small>*</small></label>
                  </div>
                  <CustomImageUpload name="thumbnail"
                    acceptedFormats={[".webp"]}
                    onImageChange={handleChange}
                    imagePreview={previews.thumbnail} />
                </div>
              </div>
            </div>
          </div>
        </form>

        <button type="submit" form="branchEdit" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
